<template>
    <BreadCrumb PageTitle="Modifier une correction request" />
     <EditCorrectionRequest/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditCorrectionRequest from "@/components/CorrectionRequest/EditCorrectionRequest.vue";

  
    export default defineComponent({
      name: "EditCorrectionRequestPage",
      components: {
        BreadCrumb,
        EditCorrectionRequest,
      },
    });
</script>